import { render, staticRenderFns } from "./BooksPage.html?vue&type=template&id=0539adf5&scoped=true&"
import script from "./BooksPage.ts?vue&type=script&lang=ts&"
export * from "./BooksPage.ts?vue&type=script&lang=ts&"
import style0 from "./BooksPage.scss?vue&type=style&index=0&id=0539adf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539adf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
